"use client";

import {
	HmcLabsCol,
	HmcLabsRow,
	HmcLabsGrid,
} from "@adi-ctx/harmonic-labs-react";
import ResourceCard from "../ResourceCard/ResourceCard";
import type { TResourceCard } from "../ResourceCard/resource-card.types";
import type { TResources } from "./resources.types";

export default function Resources({ resourcesData }: TResources) {
	return (
		<HmcLabsGrid
			data-testid="resources"
			fixed={false}
			className="mx-[-20px] md:mx-0"
		>
			<HmcLabsRow>
				{resourcesData.map((resource: TResourceCard) => (
					<HmcLabsCol
						key={resource.title}
						size="12"
						size-md="6"
						size-lg="4"
						className="mb-5"
					>
						<ResourceCard
							icon={resource.icon}
							title={resource.title}
							text={resource.text}
							link={resource.link}
						/>
					</HmcLabsCol>
				))}
			</HmcLabsRow>
		</HmcLabsGrid>
	);
}
